/*
 * Created by: cparaschiv
 * Date: 22.11.2013, 16:45
 */

TS.ns('TS.domain.properties');

(function () {
	'use strict';

	var baseMappings = TS.domain.properties.DomainProperty.prototype.mapping;

	TS.domain.properties.FileUploadProperty = new Class(
		/** @lends TS.domain.properties.FileUploadProperty# */
		{
			Extends: TS.domain.properties.DomainProperty,

			mapping: $.extend(baseMappings, {
				ignore: baseMappings.ignore.concat([]),
				copy: baseMappings.copy.concat(['MaxFileSize']),
				suppress: baseMappings.suppress.concat(['MaxFileSize'])
			}),

			initialize: function (domain, config) {
				var me = this;
				me.parent(domain, config);
				me.CancelVisible = ko.observable(false);
			},
			

			onSelectFileClick: function () {
				TS.log('onSelectFile');

			},

			onCancelClick: function () {
				TS.log('onCancel');
			}
		});


	TS.ObjectFactory.map('FileUploadProperty', TS.domain.properties.FileUploadProperty);
})();